export default "__VITE_ASSET__iY868qrb__"